import React, { useState } from "react";
import "./RenameModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import AddModalInputField from "../../../AddModalInputField/AddModalInputField";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";

export default function RenameModal({ isOpen, onClose, onConfirm, title, setTitle }) {
    const { toastWarning } = useToaster();
    const { getTranslation } = useLanguage();

    if (!isOpen) return null;

    const handleRename = () => {
        if (title.trim() === "") {
            toastWarning(getTranslation("titleCantBeEmpty"));
            return;
        }
        onConfirm(title)
        onClose();
        setTitle("");
    };

    return (
        <div className="rename-modal-overlay">
            <div className="rename-modal-container">
                <IoCloseOutline
                    className="rename-modal-button close"
                    onClick={onClose}
                />
                <p className="rename-modal-title">
                    {getTranslation("rename")}
                </p>

                <AddModalInputField icon={<TbStack2 size={22} style={{ width: "25px" }} />} placeholder={getTranslation("title") + "*"} value={title} onChange={(e) => setTitle(e.target.value)} type={"text"} />


                <div className="rename-modal-actions">
                    <button
                        className="rename-modal-button create"
                        onClick={handleRename}
                    >
                        {getTranslation("rename")}
                    </button>
                </div>
            </div>
        </div>
    );
}
